import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 27,
    type: CHECKLIST_ITEM_TYPE.PAYMENT_METHOD,
    manifestKey: 'PAYMENT_METHOD',

    try_it: {
        button_label: 'Select Payment Method',
        // Structured-data types fall through to ConfirmationCell (default) in the switch — no dedicated cell exists yet.
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'ConfirmationCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { method: 'card' },
        },
    },
    pre_flight_diff: [
        '⚠ value will NOT persist — known bug (BE-#273-cleanup)',
        'PATCH /checklist/{iid}/ with value="card"|"cash"|"finance" → 200 but value silently dropped',
        'No method whitelist validation on BE',
        'Checklist item: PENDING → YES (via complete POST only)',
        'Payment method can be stored in response_payload on complete POST (workaround)',
    ],
    has_step2_throttle: false,
    validation_laboratory: [
        {
            label: 'PATCH value="card" (silent-drop)',
            body: { value: 'card' },
            expected: '200 but value not persisted (silent drop) — GET confirms field absent',
        },
        {
            label: 'PATCH value="ARBITRARY_METHOD"',
            body: { value: 'ARBITRARY_METHOD' },
            expected: '200 accepted — no method whitelist + value still silently dropped',
        },
    ],
};
